import { render, staticRenderFns } from "./DriverSlider.vue?vue&type=template&id=2bfbd29a&"
import script from "./DriverSlider.vue?vue&type=script&lang=js&"
export * from "./DriverSlider.vue?vue&type=script&lang=js&"
import style0 from "./DriverSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports